import React, {useState} from 'react';
import {Iterable} from 'immutable';

import {DropdownItem, IconButton} from '@albert-io/atomic';
import {getMarkdownRenderer} from 'generic/MarkdownRendererV2/markdownRendererRef';

import './free-form.scss';

interface FreeFormProps {
  content: any;
  name: string;
}

const FreeForm = ({content, name}: FreeFormProps) => {
  const [isHidden, setIsHidden] = useState(true);
  const freeFormContent = Iterable.isIterable(content) ? content.toJS() : content;

  let freeFormText = freeFormContent.text;
  if (!freeFormText) {
    freeFormText = 'No content entered.';
  }

  const MarkdownRendererV2 = getMarkdownRenderer();

  return (
    <div className='rounded-x1 border border-solid border-border-primary background-primary'>
      <DropdownItem
        as='button'
        bold={false}
        onClick={(e) => {
          e.stopPropagation();
          setIsHidden(!isHidden);
        }}
        className='free-form__dropdown-item rounded-x1 p-x1'
        data-testid='free-form__expandable-item'
      >
        <IconButton
          as='div'
          size='s'
          aria-hidden
          icon={isHidden ? 'chevron-right' : 'chevron-down'}
          tooltip={isHidden ? 'Expand' : 'Collapse'}
          tooltipProps={{placement: 'top'}}
        />
        <MarkdownRendererV2 className='ml-x2 py-x1 text-wrap' text={name} />
      </DropdownItem>
      {!isHidden && (
        <div className='px-x2 pt-x1 pb-x2'>
          <MarkdownRendererV2 text={freeFormText} data-testid='free-form__markdown-renderer' />
        </div>
      )}
    </div>
  );
};

export default FreeForm;
